import React from 'react';
import { FaGithub, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import { SOCIALS } from './Navigation';
import './styles/Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <a
          className="footer-brand"
          href="#home"
          onClick={(event) => {
            event.preventDefault();
            const home = document.getElementById('home');
            if (home) home.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <span className="footer-mark" aria-hidden="true">
            AA
          </span>
          Adiba Akter
        </a>

        <p className="footer-credit">
          Designed and developed by Adiba Akter. © {year}.
        </p>

        <div className="footer-socials">
          <a
            href={SOCIALS.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
          >
            <FaGithub aria-hidden="true" />
          </a>
          <a
            href={SOCIALS.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile"
          >
            <FaLinkedinIn aria-hidden="true" />
          </a>
          <a href={`mailto:${SOCIALS.email}`} aria-label="Email Adiba">
            <FaEnvelope aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
